import { render } from "./TemplateNine.vue?vue&type=template&id=2dec423c"
import script from "./TemplateNine.vue?vue&type=script&lang=js"
export * from "./TemplateNine.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__